var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
!function (o, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("proj4"), require("@turf/boolean-point-in-polygon")) : "function" == typeof define && define.amd ? define(["proj4", "@turf/boolean-point-in-polygon"], e) : "object" == typeof exports ? exports["dotted-map"] = e(require("proj4"), require("@turf/boolean-point-in-polygon")) : o["dotted-map"] = e(o.proj4, o["@turf/boolean-point-in-polygon"]);
}(this, function (o, e) {
  return function () {
    "use strict";

    var t = {
        620: function _(o) {
          o.exports = e;
        },
        25: function _(e) {
          e.exports = o;
        }
      },
      r = {};
    function n(o) {
      var e = r[o];
      if (void 0 !== e) return e.exports;
      var i = r[o] = {
        exports: {}
      };
      return t[o](i, i.exports, n), i.exports;
    }
    n.n = function (o) {
      var e = o && o.__esModule ? function () {
        return o.default;
      } : function () {
        return o;
      };
      return n.d(e, {
        a: e
      }), e;
    }, n.d = function (o, e) {
      for (var t in e) n.o(e, t) && !n.o(o, t) && Object.defineProperty(o, t, {
        enumerable: !0,
        get: e[t]
      });
    }, n.o = function (o, e) {
      return Object.prototype.hasOwnProperty.call(o, e);
    }, n.r = function (o) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(o, "__esModule", {
        value: !0
      });
    };
    var i = {};
    return function () {
      n.r(i), n.d(i, {
        default: function _default() {
          return a;
        }
      });
      var o = n(25),
        e = n.n(o),
        t = n(620),
        r = n.n(t);
      var a = function a(_ref) {
        var o = _ref.map,
          _ref$avoidOuterPins = _ref.avoidOuterPins,
          t = _ref$avoidOuterPins === void 0 ? !1 : _ref$avoidOuterPins;
        var n = o.points,
          i = o.X_MIN,
          a = o.Y_MAX,
          s = o.X_RANGE,
          p = o.Y_RANGE,
          l = o.region,
          u = o.grid,
          d = o.width,
          c = o.height,
          f = o.ystep;
        return {
          addPin: function addPin(_ref2) {
            var o = _ref2.lat,
              l = _ref2.lng,
              g = _ref2.data,
              y = _ref2.svgOptions;
            var _e = e()(e().defs("GOOGLE"), [l, o]),
              _e2 = _slicedToArray(_e, 2),
              v = _e2[0],
              b = _e2[1];
            if (t) {
              var _o = e()(e().defs("GOOGLE"), e().defs("WGS84"), [v, b]);
              if (!r()(_o, poly)) return;
            }
            var j = d * (v - i) / s,
              x = c * (a - b) / p;
            var h = Math.round(x / f);
            h % 2 == 0 && "diagonal" === u && (j -= .5);
            var O = Math.round(j);
            var m = O,
              $ = Math.round(h) * f;
            h % 2 == 0 && "diagonal" === u && (m += .5);
            var M = {
              x: m,
              y: $,
              data: g,
              svgOptions: y
            };
            return n[[O, h].join(";")] = M, M;
          },
          getPoints: function getPoints() {
            return Object.values(n);
          },
          getSVG: function getSVG(_ref3) {
            var _ref3$shape = _ref3.shape,
              o = _ref3$shape === void 0 ? "circle" : _ref3$shape,
              _ref3$color = _ref3.color,
              e = _ref3$color === void 0 ? "current" : _ref3$color,
              _ref3$backgroundColor = _ref3.backgroundColor,
              t = _ref3$backgroundColor === void 0 ? "transparent" : _ref3$backgroundColor,
              _ref3$radius = _ref3.radius,
              r = _ref3$radius === void 0 ? .5 : _ref3$radius;
            return "<svg viewBox=\"0 0 ".concat(d, " ").concat(c, "\" xmlns=\"http://www.w3.org/2000/svg\" style=\"background-color: ").concat(t, "\">\n        ").concat(Object.values(n).map(function (_ref4) {
              var t = _ref4.x,
                n = _ref4.y,
                _ref4$svgOptions = _ref4.svgOptions,
                i = _ref4$svgOptions === void 0 ? {} : _ref4$svgOptions;
              var a = i.radius || r;
              if ("circle" === o) return "<circle cx=\"".concat(t, "\" cy=\"").concat(n, "\" r=\"").concat(a, "\" fill=\"").concat(i.color || e, "\" />");
              if ("hexagon" === o) {
                var _o2 = Math.sqrt(3) * a;
                return "<polyline points=\"".concat([[t + _o2, n - a], [t + _o2, n + a], [t, n + 2 * a], [t - _o2, n + a], [t - _o2, n - a], [t, n - 2 * a]].map(function (o) {
                  return o.join(",");
                }).join(" "), "\" fill=\"").concat(i.color || e, "\" />");
              }
            }).join("\n"), "\n      </svg>");
          },
          image: {
            region: l,
            width: d,
            height: c
          }
        };
      };
    }(), i;
  }();
});